/// <reference path="../../../../../typings/jquery.d.ts"/>
import { AppUtils } from '../../../../../../shared/utils/index';
import { User } from '../../../../../../shared/models/api/User/User';
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { UploadPersistenceService } from '../../../../../../shared/services/UploadPersistenceService';

export class ConfirmationOhcPageController implements StepController {
	private readonly $ctx: JQuery;
	private readonly user: User;
	private readonly options: DamageDeclarationOhcOptions;
	private readonly appViewService: AppViewService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly parent: AppController;
	private readonly uploadPersistenceService: UploadPersistenceService;

	constructor(parent: AppController, options: DamageDeclarationOhcOptions, loader: BasicLoader<DamageDeclarationOhcAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.user = user;
		this.$ctx = $(options.$ctx);
		this.appPersistenceService = new AppPersistenceService(options);
		this.uploadPersistenceService = new UploadPersistenceService(options);
		this.appViewService = new AppViewService(parent, options, loader);

	}

	public start(): void {
		if (this.checkPreconditions()) {
			const viewConfig = {
				data: this.getViewOptions(),
				templateurl: this.options.app.currenttemplate.templateurl,
				campaignurls: this.options.app.campaignurls,
				parent: this,
				$ctx: this.$ctx,
				options: this.options,
				callback: this.afterRenderApp
			};
			this.appViewService.render(viewConfig);
		} else {
			T.Utils.Helper.routeToUrl(this.options.app.entryredirecturl);
		}
	}

	private checkPreconditions(): boolean {
		const checkModel = this.appPersistenceService.getCheckFormModelFromStore();
		return $('body').hasClass(this.options.app.pageEditorClass) || (checkModel !== undefined);
	}

	/**
	 * returns view options for the page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): { [key: string]: any } {
		const formModel = this.appPersistenceService.getApplicationModel();
		const uploadModel = this.uploadPersistenceService.getUploadModelFromStore();
		return {
			User: this.user,
			FormModel: formModel,
			UploadModel: uploadModel,
			prevurl: this.options.app.prevurl || '',
		};
	}

	public afterRenderApp(): void {
		T.Utils.Tracking.pushKameleoonData();
		this.parent.afterRenderApp();
		const checkFormModel = this.appPersistenceService.getCheckFormModelFromStore();
		this.appViewService.setTimestampToView(checkFormModel.TimeStamp);
		this.appPersistenceService.clearApplicationSession();
		this.uploadPersistenceService.clearApplicationSession();
		AppUtils.View.stopLoader("damagedeclarationohc initApplication");
		AppUtils.View.scrollTop();
	}

}
